import { Box, Link } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { useLogin } from "utils/useLogin";

interface Props {
  trackSubscription: (isAbandoned?: boolean) => void;
}

const NotInterestedButton = ({ trackSubscription }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isNewUser } = useLogin();

  const navigateToDashboard = async () => {
    trackSubscription(true);

    if (isNewUser) {
      navigate(`/${routes.onboardingInfluencer}${location.pathname}`);
    } else {
      navigate(`/${routes.dashboard}${location.pathname}`);
    }
  };

  return (
    <Link
      onClick={navigateToDashboard}
      sx={{
        fontSize: 12,
        color: grey[400],
        cursor: "pointer",
        textDecoration: "none",
        "&:hover": { color: grey[600] },
      }}
    >
      Go to dashboard{" "}
      <Box
        component="i"
        className="fa-solid fa-arrow-up-right-from-square"
        sx={{ ml: 0.5 }}
      />
    </Link>
  );
};

export default NotInterestedButton;
